import React from 'react';

import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';
import OrdersTable from './OrdersTable';
import Page from '../page/Page';
import useOrders from '../../hooks/orders/useOrders';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
}));

const OrdersPage = () => {
  const classes = useStyles();
  const { data, loading } = useOrders();

  if (loading) return <div />;

  return (
    <Page>
      <Typography variant="h3" className={classes.header}>Orders</Typography>
      <OrdersTable orders={data?.orders?.edges} />
    </Page>
  );
};

export default OrdersPage;
